import { useLocation } from 'react-router-dom';
import {
  SortMenuOption,
  SortOptions,
} from 'src/components/subHeader/SubHeaderWithSorting.interface';
import { useGetAllLayouts, useParamQuery } from 'src/hooks';
import { formatQuery } from 'src/utils';

export const useListLayoutsPage = () => {
  const { onChangeParams, getParamsValue } = useParamQuery({
    sort: ['-modified_at'],
  });
  const location = useLocation();

  const {
    data: layoutsDetails = { pages: [], pageParams: [] },
    isLoading: isLayoutsLoading,
    error: errorLayouts,
    hasNextPage,
    fetchNextPage,
  } = useGetAllLayouts(formatQuery(location.search));

  const getNextLayoutPage = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const totalNumOfLayouts = layoutsDetails?.pages?.reduce((acc, page) => {
    acc += page.layouts.length;

    return acc;
  }, 0);

  const selectedSortOption: SortMenuOption = {
    option: getParamsValue('sort')[0]?.replace('-', '') as SortOptions,
    order: getParamsValue('sort')[0]?.includes('-') ? 'desc' : 'asc',
  };

  const onSortChangeHandle = (selectedOption: {
    option: SortOptions;
    order: 'desc' | 'asc';
  }) => {
    onChangeParams('sort', [
      `${selectedOption.order === 'desc' ? '-' : ''}${selectedOption.option}`,
    ]);
  };

  return {
    layoutsDetails,
    onChangeParams,
    isLayoutsLoading,
    errorLayouts,
    getNextLayoutPage,
    totalNumOfLayouts,
    selectedSortOption,
    onSortChangeHandle,
  };
};
